import { render, staticRenderFns } from "./TestResultStatusComponent.vue?vue&type=template&id=7bb6769d&scoped=true"
import script from "./TestResultStatusComponent.vue?vue&type=script&lang=ts"
export * from "./TestResultStatusComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb6769d",
  null
  
)

export default component.exports